module.exports = __webpack_public_path__ + "static/media/clock-dark.bd4f7f94.svg";